export const UPDATE_CC_DETAILS = 'mac/UPDATE_CC_DETAILS';
